import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PageGrid = styled(Grid, {
  shouldForwardProp: (prop) =>
    prop !== "noPadding" && prop !== "headerHeight" && prop !== "footerHeight" && prop !== "overflowHidden",
})(({ noPadding, headerHeight, footerHeight, overflowHidden, theme }) => ({
  height: `calc(100vh - ${theme.navbarSize})`,
  maxWidth: "100%",
  overflow: overflowHidden ? "hidden" : "auto",
  marginLeft: 0,
  marginRight: 0,
  padding: theme.spacing(noPadding ? 0 : 3),
  paddingTop: headerHeight > 0 || noPadding ? 0 : theme.spacing(3),
  "& >div:first-of-type": {
    paddingBottom: footerHeight > 0 || noPadding ? `${footerHeight}px` : theme.spacing(3),
  },
}));
